import { defineMessages } from 'react-intl-next';

export const messages: {
	noPaymentDetailsLegalTextPremium: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	noPaymentDetailsLegalTextStandard: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	paymentDetailsLegalText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	noPaymentDetailsLegalTextStandard: {
		id: 'twc.xflow.modal.legal.noPaymentDetailsLegalTextStandard.v2',
		defaultMessage:
			'Cancel anytime. By selecting "{cta}" you agree to the <tc>Atlassian Customer Agreement</tc> and <pp>Privacy Policy.</pp>',
		description:
			'Common legal notice for tenants that do not have payment details on file and edition is standard',
	},
	noPaymentDetailsLegalTextPremium: {
		id: 'twc.xflow.modal.legal.noPaymentDetailsLegalTextPremium.v2',
		defaultMessage:
			'Cancel anytime. By selecting "{cta}" you agree to the <tc>Atlassian Customer Agreement</tc> and <pp>Privacy Policy.</pp>',
		description:
			'Common legal notice for tenants that do not have payment details on file and edition is premium',
	},
	paymentDetailsLegalText: {
		id: 'twc.xflow.modal.legal.paymentDetailsLegalText.v2',
		defaultMessage:
			'By selecting "{cta}" you agree to the <tc>Atlassian Customer Agreement</tc> and <pp>Privacy Policy.</pp> {br}If you don\'t cancel during the trial, subscription billing will begin and renew monthly based on pricing of Teamwork Collection. Cancel anytime.{br}',
		description: 'Common legal notice for tenants that do not have payment details on file',
	},
});
